import { createContext } from 'react';

const ApiContext = createContext({
	state: {},
	dispatch: () => {},
	actions: {},
});

export default ApiContext;
